export default __webpack_public_path__ + "static/media/fonts/alegreyasans-regular-webfont.8035f6e8.woff";